import { render } from "./FormPassword.vue?vue&type=template&id=766d5e32&ts=true"
import script from "./FormPassword.vue?vue&type=script&lang=ts"
export * from "./FormPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__